import {
  SAVE_PROMOTION_INFORMATION,
  SAVE_SELECTED_RECEPIENDS,
  SAVE_COMMON_POINTS_FOR_ALL_RECEPIENTS,
  SET_CHECKBOX_FOR_EACH_RECEPIENTS,
  SAVE_POINTS_FOR_SINGLE_MULTI_USER,
  SAVE_BEHAVIOUR_DETAILS,
  ADD_POINTS_FOR_CUSTOM_USER,
  SET_CHECKBOX_FOR_RECOGNITION_PRIVATE,
  SAVE_UPLOADED_IMAGE_INFO,
  GET_ALL_SELECTED_PROMOTION,
  ALL_PROMOTION,
  SENT_RECOGNITION_INFORMATION,
  SAVE_LOGIN_RESPONSE,
  SAVE_TEAM_MEMBER_LIST,
  SAVE_RECOGNIZE_LIST,
  USER_DETAILS,
  FILTERS,
  SAVE_COPYOTHERS_RECEPIENDS,
  REMOVE_COPYOTHERS_RECEPIENDS,
  SET_COPY_ME,
  SET_COPY_MANAGER,
  COPY_OTHERS_EMAIL,
  CLEAR_COPY_OTHERS_EMAIL,
  SELECTED_PARTICIPANT_ID,
  RESTORE_RECEPIENDS
} from "./actionTypes";
import _ from "lodash";

export const savePromotionId = (promotion) => {
  return {
    type: SAVE_PROMOTION_INFORMATION,
    promotion,
  };
};

export const saveRecipient = (item) => {
  return {
    type: SAVE_SELECTED_RECEPIENDS,
    item,
  };
};

export const saveCopyOthersRecipient = (item) => {
  return {
    type: SAVE_COPYOTHERS_RECEPIENDS,
    item,
  };
};

export const removeCopyOthersRecipient = (item) => {
  return {
    type: REMOVE_COPYOTHERS_RECEPIENDS,
    item
  };
};

export const savesingleUserPoints = (numberObj) => {
  return {
    type: SAVE_COMMON_POINTS_FOR_ALL_RECEPIENTS,
    numberObj,
  };
};

export const checkBoxSelectionforRecipient = (checked) => {
  return {
    type: SET_CHECKBOX_FOR_EACH_RECEPIENTS,
    checked,
  };
};

export const setPointsforEachUser = (data) => {
  return {
    type: SAVE_POINTS_FOR_SINGLE_MULTI_USER,
    data,
    sum: _.sumBy(data, (e) => Math.round(e.budgetPoints)),
  };
};

export const saveBehaviorInfo = (data) => {
  return {
    type: SAVE_BEHAVIOUR_DETAILS,
    data,
  };
};

export const addPointsForCustomUser = (points) => {
  return {
    type: ADD_POINTS_FOR_CUSTOM_USER,
    points,
  };
};

export const setCheckboxPrivate = (checked) => {
  return {
    type: SET_CHECKBOX_FOR_RECOGNITION_PRIVATE,
    checked,
  };
};

export const setCopyManager = (checked) => {
  return {
    type: SET_COPY_MANAGER,
    checked,
  };
};

export const setCopyMe = (checked) => {
  return {
    type: SET_COPY_ME,
    checked,
  };
};
export const selectedParticipantId = (data) => {
  return {
    type: SELECTED_PARTICIPANT_ID,
    data
  };
};
export const setCopyOthersEmail = (data) => {
  return {
    type: COPY_OTHERS_EMAIL,
    data
  };
};
export const clearCopyOthersEmail = () => {
  return {
    type: CLEAR_COPY_OTHERS_EMAIL,
  };
};

export const restoreCopyOthersEmail = (item) => {
  return {
    type: RESTORE_RECEPIENDS,
    item
  };
};

export const saveCustomImageInfo = (data) => {
  return {
    type: SAVE_UPLOADED_IMAGE_INFO,
    data,
  };
};

export const setAllPromotion = (data) => {
  return {
    type: GET_ALL_SELECTED_PROMOTION,
    data,
  };
};

export const getAllPromotionsList = (data) => {
  return {
    type: ALL_PROMOTION,
    data,
  };
};

export const saveRecognitationInformation = (data) => {
  return {
    type: SENT_RECOGNITION_INFORMATION,
    data,
  };
};

export const saveLoginInformation = (data) => {
  return {
    type: SAVE_LOGIN_RESPONSE,
    data,
  };
};

export const saveTeamMemberList = (data) => {
  return {
    type: SAVE_TEAM_MEMBER_LIST,
    data,
  };
};

export const saveRecognizeList = (data) => {
  return {
    type: SAVE_RECOGNIZE_LIST,
    data,
  };
};

export const getLoggedInUserDetails = (data) => {
  return {
    type: USER_DETAILS,
    data,
  };
};

export const saveFilters = (data) => {
  return {
    type: FILTERS,
    data,
  };
};



